import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography'
import Link from '@material-ui/core/Link'


const classes=  {
    h1 : {
        margin:'left',
        align:'left',
        justify:'left',
        color: '#009688',
        paddingTop:30,
        width:'100%',
        marginBottom:20,
        
        borderTop: 'solid 0.02em',
        },
    h2 : {
    margin:'auto',
    align:'left',
    justify:'left',
    color: '#009688',
    paddingBottom:30,
    borderBottom: 'solid 0.04em',
    width:'100%',
    marginBottom:60,
    fontStyle:'italic'
    },
    p: {
       color: '#4A4A4A'
    }
}
export class Program extends Component {
    render() {
        return ( 
            
               <div align="left" style={{margin:'7%'}}>
                 <Typography variant="h3" style={classes.h1}>
                   Registration 
                </Typography>
            
                <Typography style={classes.p}>
                   Registration is closed.
                </Typography>
                <br></br>
                
                <br></br>

            </div>
            )
        }
    }


export default Program;